import React from 'react';

import InternationalizationStore from '../../../store/internationalization-store.js'
import { FormControl, FormGroup, Form, Row, Col,Alert } from 'react-bootstrap';
import ClassService from '../../../services/classes-service.js';
import InternationalisationStore from '../../../store/internationalization-store.js';
import LanguageSelector from "../../language_select.js";
import LanguageInterfaceSelector from "../../language_select.js";
import Select from 'react-select';
import { DateRangePicker} from 'react-dates';
import moment from 'moment';
import Translation from '../../../store/internationalization-store.js';
import ClassesStore from '../../../store/classes-store.js';
import Constants from '../../../constants.js'
import Table from '../../general_table.js';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import Checkbox from '../../checkbox.js';


class FormattedMessage extends React.Component {
    constructor(props) {
        super();
        this.props = props;
    }

    render(){
        return <span>{InternationalizationStore.get(this.props.id , this.props.defaultMessage)}</span>
    }
}

class Component extends React.Component {
    constructor(props) {
        super();
        this.props = props
        this.props.data.students = [];
        this.state = {
            classes:[]
        }
    }

    componentDidMount(){
        ClassService.getMine();
    }

    componentWillMount(){
        ClassesStore.on(Constants.GET_MY_CLASSES,  ()=>{
            var   classes = ClassesStore.list;
            var __classes = [];

            var index = 0 ;
            for(var i = 0 ; i < classes.length; i++)
            {
                var _class = classes[i];


                if(_class.students.length > 0)
                {
                    _class.index = index;
                    _class.selected = false;
                    _class.selectedStudents = [];
                    __classes.push(_class)
                    ++index;
                }

            }

            this.setState({
                classes:__classes
            })
        })

    }

    handelSelect(index){
        var __classes = this.state.classes;
            __classes[index].selected =  !__classes[index].selected;

        if(! __classes[index].selected)
        {
            __classes[index].selectedStudents =  [];
        }
        else
        {
            __classes[index].selectedStudents = (__classes[index].students || []).map(function(student){
                return  { value: student.uid, label: student.name}
            });
        }

        console.log(__classes[index])

        this.setState({
            classes:__classes
        })

        this.props.data.classes = __classes;
    }

    handelSelectStudents(index , values){

        var __classes = this.state.classes;
        __classes[index].selected =  true;
        __classes[index].selectedStudents =  values;


        this.setState({
            classes:__classes
        })

        this.props.data.classes = __classes;
    }

    render () {

        var columns = [
            {
                dataField: 'name',
                sort: true,
                text: Translation.get(452 , 'Class Name'),
            },
            {
                dataField: 'selectedStudents',
                text: Translation.get(498 , 'Assign To'),
                align: "left",
                style:{
                    width:'60%'
                },
                formatter:(cell , row)=>{

                    let options = (row.students || []).map(function(student){
                        return  { value: student.uid, label: student.name}
                    });

                    return <Select value={cell} disabled={row.selected} placeholder={Translation.get(-1 , '')} isMulti={true} onChange={this.handelSelectStudents.bind(this , row.index)}  options={options} noResultsText={Translation.get(12715 , 'No Results Found')} />

                }

            },
            {
                dataField: 'selected',
                style:{
                    width:'45px'
                },
                formatter:(cell , row)=>{
                    console.log('selected')
                    return <Checkbox checked={row.selected} onChange={this.handelSelect.bind(this , row.index)} inline/>
                }
            }
        ];

        return   <div>
            <Alert  variant={'primary'}>
                <b>Select the classes and student you wish to generate your certificate for</b>
            </Alert>
            <Table hideDownload={true} cellEdit={ cellEditFactory({ mode: 'click', blurToSave: true }) } columns={columns} data={this.state.classes || []} />
        </div>
    }


}

export default {
    name: <FormattedMessage id={'0'} defaultMessage={'Select Certificate'} />,
    title: null,
    onSubmit: function (done) {

        if(this.props.data.classes.length >= 0 )
        {
            this.props.data.students = [];

            for(var i = 0; i < this.props.data.classes.length; i++)
            {
                var __class = this.props.data.classes[i];
                this.props.data.students = this.props.data.students.concat(__class.selectedStudents);
            }
        }

        if(this.props.data.students.length <= 0 ){
            return done(new Error(InternationalizationStore.get('ui-000' ,'No Students have been selected' )));
        } else {
            return done()
        }
    },
    value: null,
    component: Component
}